

































import groupRow from './groupRow.vue'
import groupScroller from './groupScroller.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
@Component({
  components: { groupRow, groupScroller },
})
export default class SpellGroup extends Vue {
  @Prop() activity: any
  @Prop() type: any
  @Prop() isApp: boolean
  @Prop() navbarHeight
  organizerNum: number = 0
  groupOrder: any = 0
  joined: boolean = false
  organizers: any = []
  async created() {
    console.log('this.activity', this.activity)
    // 获取拼团发起者
    const { data } = await this.$axios.get(
      `/api/goods/shop/market/group/groupHomeOrganizer`,
      {
        params: { activity_id: this.activity.id, activityId: this.activity.id },
      }
    )
    this.organizerNum = data.organizer_total
    this.joined = data.verify_result && data.verify_result.joined
    this.groupOrder = data.verify_result && data.verify_result.group
    this.organizers = data.organizers
    this.$emit('updateGroup', {
      joined: this.joined,
    })
  }
  viewMyGroup() {
    this.$router.push({
      path: `/groupView`,
      query: {
        ...this.$route.query,
        orgId: this.groupOrder.group_order_id,
      },
    })
  }
  async viewGroupRule() {
    if (this.activity.rule_pic) {
      return this.$router.push(
        `/picPage?src=${this.activity.rule_pic}&isApp=${this.isApp}&height=${this.navbarHeight}`
      )
    }
  }
  groupBuyList() {
    // todo
    this.$router.push(
      `/groupList?activityId=${this.activity.id}&type=${this.type}`
    )
  }
}
